import Auth from "../components/Auth";
import Unauthorized from "../utils/Unauthorized";
import ManageFlavors from "../components/ManageFlavors";
import AdminDashboard from "../components/AdminDashboard";
import HoursOfOperation from "../components/HoursOfOperation";
import BoardAdministration from "../components/BoardAdminstration";
import FlavorsList from "../components/FlavorsList";
import DriveThru from "../components/DriveThru";
import FlavorDrivenTreats from "../components/FlavorDrivenTreats";
import DigitalRecipePortal from "../components/DigitalRecipePortal";
import TTDashboard from "../components/TTDashboard";
import Login from "../components/Login";
import PurchaseCard from "../components/PurchaseMerchandise/PurchaseCard";
import PurchaseRequest from "../components/PurchaseMerchandise/PurchaseRequest";
import ProductionSheet from "../components/ProductionSheet";
import ManageMerchandise from "../components/PurchaseMerchandise/ManageMerchandise";
import PreSellAdmin from "../components/PreSellAdmin";
import PreSellBoardConfiguration from "../components/PreSellBoardConfiguration";
import OnlineVendorOrdering from "../components/OnlineVendorOrdering/OnlineVendorOrdering";
import { ProductionSheetLayout } from "../components/ProductionSheet/ProductionSheetLayout";
import CateringPortal from "../components/CateringPortal";
import CoolAlerts from "../components/CoolAlerts";
import ShopWebsiteCustomization from "../components/ShopWebsiteCustomization/ShopWebsiteCustomization";
import FileUpload from '../components/FileUpload';
import ProfitLossTool from "../components/ProfitLossTool/ProfitLossTool";
import RFCLibrary from "../components/RfcLibrary/RFCLibrary";

export const MainRoutes = [
  {
    path: "/",
    name: "AdminDashboard",
    key: "AdminDashboard",
    component: <AdminDashboard />,
  },
  {
    path: "/admin",
    name: "AdminDashboard",
    key: "AdminDashboard",
    component: <AdminDashboard />,
  },
  {
    path: "/flavors",
    name: "Flavors",
    key: "Flavors",
    component: <FlavorsList />,
  },
  {
    path: "/auth",
    name: "Auth",
    key: "Auth",
    component: <Auth />,
  },
  {
    path: "/403",
    name: "Unauthorized",
    key: "Unauthorized",
    component: <Unauthorized />,
  },
  {
    path: "/hours-of-operation",
    name: "HoursOfOperation",
    key: "HoursOfOperation",
    component: <HoursOfOperation />,
  },
  {
    path: "/board-administration",
    name: "BoardAdministration",
    key: "BoardAdministration",
    component: <BoardAdministration />,
  },
  {
    path: "/recipes",
    name: "DigitalRecipePortal",
    key: "DigitalRecipePortal",
    component: <DigitalRecipePortal />,
  },
  {
    path: "/drive-thru",
    name: "ProductTypes",
    key: "ProductTypes",
    component: <DriveThru />,
  },
  {
    path: "/manage-flavors",
    name: "ManageFlavors",
    key: "ManageFlavors",
    component: <ManageFlavors />,
  },
  {
    path: "/flavor-driven-treats",
    name: "FlavorDrivenTreats",
    key: "FlavorDrivenTreats",
    component: <FlavorDrivenTreats />,
  },
  {
    path: "/buy-merchandise",
    name: "Buy Merchendize",
    key: "BuyMerchendise",
    component: <PurchaseCard directUrl={true} />,
  },
  {
    path: "/buy-merchandise-cart",
    name: "Buy Merchendize Cart",
    key: "BuyMerchendiseCart",
    component: <PurchaseRequest directUrl={true} />,
  },
  {
    path: "/purchase-merchendise",
    name: "Buy Merchendize",
    key: "PurchaseMerchendise",
    component: <PurchaseCard directUrl={false} />,
  },
  {
    path: "/purchase-merchendise-cart",
    name: "Purchase Merchendise Cart",
    key: "PurchaseMerchendiseCart",
    component: <PurchaseRequest directUrl={false} />,
  },
  {
    path: "/pre-sell-board-admin",
    name: "PreSellAdmin",
    key: "PreSellAdmin",
    component: <PreSellAdmin />,
  },
  {
    path: "/pre-sell-board-conf",
    name: "pre-sell-board-conf",
    key: "pre-sell-board-conf",
    component: <PreSellBoardConfiguration />,
  },
  {
    path: "/production/*",
    name: "ProductionSheet",
    key: "ProductionSheet",
    component: <ProductionSheetLayout />,
  },
  {
    path: "/manage-merchandise",
    name: "ManageMerchandise",
    key: "ManageMerchandise",
    component: <ManageMerchandise directUrl={false} />,
  },
  {
    path: "/manage-merchandise-products",
    name: "ManageMerchandiseProducts",
    key: "ManageMerchandiseProducts",
    component: <ManageMerchandise directUrl={true}/>,
  },
  {
    path: "/vendor-portal",
    name: "OnlineVendorOrdering",
    key: "OnlineVendorOrdering",
    component: <OnlineVendorOrdering />,
  },
  
  // Commenting catering-portal temporarily
  // {
  //   path: "/catering-portal/*",
  //   name: "CateringPortal",
  //   key: "CateringPortal",
  //   component: <CateringPortal />,
  // },
  {
    path: "/cool-alerts/*",
    name: "CoolAlerts",
    key: "CoolAlerts",
    component: <CoolAlerts />,
  },
  {
    path: "/shop-website-customization",
    name: "ShopWebsiteCustomization",
    key: "ShopWebsiteCustomization",
    component: <ShopWebsiteCustomization />,
  },
  {
    path: "/sales-update",
    name: "SalesUpdate",
    key: "SalesUpdate",
    component: <FileUpload />
  },
  {
    path: "/profit-loss",
    name: "ProfitLossTool",
    key: "ProfitLossTool",
    component: <ProfitLossTool />,
  },
  {
    path: "/rfc-library",
    name: "RFCLibrary",
    key: "RFCLibrary",
    component: <RFCLibrary />,
  },
];

export const TTRoutes = [
  {
    path: "/",
    name: "TTDashboard",
    key: "TTDashboard",
    component: <TTDashboard />,
  },
  {
    path: "/flavors",
    name: "Flavors",
    key: "Flavors",
    component: <FlavorsList />,
  },
  {
    path: "/hours-of-operation",
    name: "HoursOfOperation",
    key: "HoursOfOperation",
    component: <HoursOfOperation />,
  },
  {
    path: "/board-administration",
    name: "BoardAdministration",
    key: "BoardAdministration",
    component: <BoardAdministration />,
  },
  {
    path: "/drive-thru",
    name: "ProductTypes",
    key: "ProductTypes",
    component: <DriveThru />,
  },
  {
    path: "/manage-flavors",
    name: "ManageFlavors",
    key: "ManageFlavors",
    component: <ManageFlavors />,
  },
  {
    path: "/flavor-driven-treats",
    name: "FlavorDrivenTreats",
    key: "FlavorDrivenTreats",
    component: <FlavorDrivenTreats />,
  },
  {
    path: "/login",
    name: "Login",
    key: "Login",
    component: <Login />,
  },
  {
    path: "/production/*",
    name: "ProductionSheet",
    key: "ProductionSheet",
    component: <ProductionSheetLayout />,
  },
  {
    path: "/recipes",
    name: "DigitalRecipePortal",
    key: "DigitalRecipePortal",
    component: <DigitalRecipePortal />,
  },
  {
    path: "/purchase-merchendise",
    name: "Buy Merchendize",
    key: "PurchaseMerchendise",
    component: <PurchaseCard />,
  },
];